import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router";
import RemoderationQueueContainer from "~/containers/RemoderationQueueContainer";
import { getUserSlug } from "~/util/getUserSlug";

export default class ProductOptionFix extends React.Component<
  RouteComponentProps<{}>
> {
  public render() {
    if (!getUserSlug()) {
      return (
        <Redirect
          to={{
            pathname: "/auth",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return <RemoderationQueueContainer />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProductOptionFix.tsx